import { CantileverButton } from 'components/CantileverButton'
import { useScatterplotContext } from 'features/timeSeries'
import {
  ModeToggleContainer,
  SectionLabel,
  ToggleAndLabelContainer,
} from 'features/timeSeries/sharedStyles'
import React from 'react'

/**
 * Y-scale is just Single or Multi. Auto vs. custom is no longer a mode:
 * typing a min/max overrides that bound, and the Auto buttons (per pen, or
 * all pens at once) clear the overrides.
 */
export const YAxisModeSection: React.FC = () => {
  const { singleScaleMode, handleScaleModeToggle } = useScatterplotContext()

  return (
    <ToggleAndLabelContainer>
      <SectionLabel>Y-Scale</SectionLabel>
      <ModeToggleContainer>
        <CantileverButton
          size='small'
          ghost={!singleScaleMode}
          onClick={() => handleScaleModeToggle(true)}>
          Single
        </CantileverButton>
        <CantileverButton
          size='small'
          ghost={singleScaleMode}
          onClick={() => handleScaleModeToggle(false)}>
          Multi
        </CantileverButton>
      </ModeToggleContainer>
    </ToggleAndLabelContainer>
  )
}
